import { useEffect, useState } from "react";
import { AcceleratorBatch } from "../../models/AcceleratorBatch";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { TTBatchInstanceDropdown } from "../tooltips/ConfigurationTooltips";

type Props = {
  selectedFilter?: string;
  /**
   * Called when the selected filter has changed
   */
  changeFilter: (newFilter: string) => void;
  availableOptions: AcceleratorBatch[];
  /**
   * Set by parent component to modify the returned value for when all items are chosen
   */
  allOption: { label: string; value: string };
};

function labelFn(batch: AcceleratorBatch): string {
  return `${batch.batchInstanceId} - ${batch.batchInstanceName} ${batch.source === "EXTERNAL" ? "- Imported" : ""}`;
}

const BatchInstanceFilter = (props: Props) => {
  const calcSelectedFilter = () =>
    props.selectedFilter ?? props.allOption.value;
  // so we don't send the changeFilter event on first load !
  // default to either the selected option, or the All option
  const [filter, setFilter] = useState<string>(calcSelectedFilter());

  // change state when prop changes
  useEffect(() => {
    if (props.selectedFilter !== filter) {
      setFilter(props.selectedFilter ?? props.allOption.value);
    }
  }, [props.selectedFilter]);
  // call fitler change when state updates
  useEffect(() => {
    // don't call prop.changeFilter when prop changes / some other reason ?
    if (calcSelectedFilter() === filter) {
      return;
    }
    props.changeFilter(filter);
  }, [filter]);

  const options = props.availableOptions.map((accBatch) => {
    return {
      label: labelFn(accBatch),
      value: accBatch.uuid,
    };
  });

  return (
    <AdvancedTooltip
      short
      tooltipText={TTBatchInstanceDropdown}
      overflow
      possiblePlacements={["bottom-center"]}
    >
      {(tProps) => (
        <select
          {...tProps}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value={props.allOption.value} label={props.allOption.label}>
            {props.allOption.label}
          </option>
          {options.map((opt, i) => (
            <option key={opt.value + i} value={opt.value} label={opt.label}>
              {opt.label}
            </option>
          ))}
        </select>
      )}
    </AdvancedTooltip>
  );
};

export { BatchInstanceFilter };
